<section class="create-pwd-page">
    <div class="create-pwd-wrapper">
        <div class="create-pwd card">
            <div class="section1">
                <div class="logoImgBox">
                    <img src="../../../assets/new-dash/logo/revenuedLogo_black.png" class="logoImg"
                        alt="Revenued Logo" />
                </div>
                <div class="formBox">
                    <ng-template *ngIf="isValidatingToken; else formContent">
                        <ngx-skeleton-loader count="1" appearance="line"
                            [theme]="{ height: '50px', width: '100%', margin: '10px 0' }"></ngx-skeleton-loader>
                    </ng-template>

                    <ng-template #formContent>
                        <ng-container *ngIf="createPasswordFlag === CreatePasswordStep.STEP1">
                            <h1 class="welcomeTitle">
                                Create Password?
                            </h1>
                            <p class="welcomePara">
                                Your new password must be unique and contain at least 12 characters with at least 1
                                special
                                character, 1 uppercase letter, 1 lowercase letter, and 1 number,  Spaces are not allowed.
                            </p>
                            <form id="form" [formGroup]="createPasswordForm">
                                <!-- New Password -->
                                <mat-form-field appearance="outline" class="myMatFormFieldCustom w-100"
                                    subscriptSizing="dynamic">
                                    <input matInput placeholder="Enter New Password" formControlName="newPassword"
                                        [type]="fieldTextType ? 'text' : 'password'"
                                        aria-label="Please enter your new password. This is a required field.">
                                    <i matSuffix class="fa mouse-pointerz iconBoxSuffix"
                                        [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"
                                        (click)="toggleFieldTextType()"></i>
                                    <mat-error *ngIf="newPassword?.touched && newPassword?.errors?.['required']">
                                        New password is required.
                                    </mat-error>
                                    <mat-error *ngIf="newPassword?.touched && newPassword?.errors?.['pattern']">
                                        Password must contain at least 12 characters, including 1 special character, 1
                                        uppercase letter, 1 lowercase letter, and 1 number, Spaces are not allowed.
                                    </mat-error>
                                </mat-form-field>

                                <!-- Confirm Password -->
                                <mat-form-field appearance="outline" class="myMatFormFieldCustom w-100"
                                    subscriptSizing="dynamic">
                                    <input matInput placeholder="Confirm Password" formControlName="confirmPassword"
                                        [type]="fieldTextType1 ? 'text' : 'password'"
                                        aria-label="Please enter your new password for confirmation. This is a required field.">
                                    <i matSuffix class="fa mouse-pointerz iconBoxSuffix"
                                        [ngClass]="{'fa-eye-slash': !fieldTextType1, 'fa-eye': fieldTextType1}"
                                        (click)="toggleFieldTextType1()"></i>
                                       
                                        <mat-error *ngIf="confirmPassword?.touched && confirmPassword?.hasError('required')">
                                            Confirmation password is required.
                                          </mat-error>
                                          
                                          <mat-error *ngIf="confirmPassword?.touched && confirmPassword?.hasError('passwordMismatch')">
                                            Passwords do not match.
                                          </mat-error>                                          
                                  
                                </mat-form-field>

                                <button class="primary-general-btn w-100"
                                    [disabled]="!(createPasswordForm.valid) || isSetPasswordProcessing"
                                    [class.disabled-link]="createPasswordForm.invalid || isSetPasswordProcessing"
                                    (click)="setPassword()" matRipple>
                                    <span *ngIf="isSetPasswordProcessing; else generalCondition">
                                        <app-loader></app-loader>
                                    </span>
                                    <ng-template #generalCondition>
                                        <span>Set Password</span>
                                    </ng-template>
                                </button>
                            </form>

                            <div class="bottom-action-links">
                                <a href="javascript:void(0);" routerLink="/login" class="link-items">
                                    <figure>
                                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg"
                                            width="19.371" height="11.662" viewBox="0 0 19.371 11.662">
                                            <path id="Path_53" data-name="Path 53"
                                                d="M8.489,8.941a.8.8,0,0,1,0,1.135L4.811,13.754h15.82a.8.8,0,1,1,0,1.6H4.827l3.662,3.654a.8.8,0,1,1-1.127,1.127L2.276,15.049a.7.7,0,0,1,0-1.015L7.353,8.941a.8.8,0,0,1,1.135,0Z"
                                                transform="translate(-2.06 -8.704)" fill="#62cdf2" />
                                        </svg>
                                    </figure>
                                    Back To Sign-In
                                </a>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="createPasswordFlag === CreatePasswordStep.STEP2">
                            <h1 class="welcomeTitle">
                                Oops! Link Expired
                            </h1>
                            <p class="welcomePara mt-4">
                                The link has expired. Please request a new link to reset your password.
                            </p>
                            <button id="open-toast" class="primary-general-btn w-100" [disabled]="isSentEmailProcessing"
                                matRipple (click)="presentToast()">
                                <!-- Request New Link -->
                                <span *ngIf="isSentEmailProcessing; else generalCondition">
                                    <app-loader></app-loader>
                                </span>
                                <ng-template #generalCondition>
                                    <span>Resend Link</span>
                                </ng-template>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="createPasswordFlag === CreatePasswordStep.STEP3">
                            <h1 class="welcomeTitle">
                                New Link Sent
                            </h1>
                            <p class="welcomePara mt-4">
                                Please continue from invitation.
                            </p>
                        </ng-container>
                    </ng-template>
                </div>
            </div>
            <div class="section2">
                <div class="inner-div">
                    <!-- <p class="content">
              A card that cares less about FICO and more about your business
            </p> -->
                    <figure class="m-0">
                        <img src="../../../assets/new-dash/login/createPwd.webp" alt="Forgot Password" />
                    </figure>
                </div>
            </div>
        </div>
        <div class="toastWrapper">
            <!-- <ion-button id="open-toast" expand="block">Open</ion-button> -->
            <!-- <ion-toast class="custom-toast" trigger="open-toast" positionAnchor="footer" message="
            A new link has been sent to your email address. Please check your email to reset your password."
                [duration]="5000"></ion-toast> -->
        </div>
        <footer class="footer--forgotPwd">
            <div class="footerMenu">
                <a href="https://www.revenued.com/about/" class="footerMenuLink" target="_blank">
                    About Revenued
                </a>
                <a href="https://www.revenued.com/contact/" class="footerMenuLink" target="_blank">
                    Contact Us
                </a>
                <a href="https://www.revenued.com/revenued-cardholder-agreement/" class="footerMenuLink"
                    target="_blank">
                    Card User Agreement
                </a>
                <a href="https://www.revenued.com/terms" target="_blank" class="footerMenuLink">
                    Terms of Service
                </a>
                <a href="https://www.revenued.com/privacy-policy" target="_blank" class="footerMenuLink">
                    Privacy Policy
                </a>
            </div>
        </footer>
    </div>
    <!-- <div class="bgImage"></div> -->
</section>